import api from "./client";

// ── Admin Settings API ────────────────────────────────────────────────────────

export const adminApi = {
  // Localization
  getLocalization: () => api.get("/admin/settings/localization"),
  updateLocalization: (data: {
    defaultLanguage?: string;
    availableLanguages?: string[];
  }) => api.put("/admin/settings/localization", data),

  // User language
  getUserLanguage: () =>
    api.get<
      import("./client").ApiEnvelope<{
        preferredLanguage: string | null;
        companyDefault?: string | null;
      }>
    >("/admin/user-language"),
  updateUserLanguage: (language: string) =>
    api.put("/admin/user-language", { language }),

  // Typography
  getTypography: () => api.get("/admin/settings/typography"),
  updateTypography: (data: Record<string, string | null>) =>
    api.put("/admin/settings/typography", data),

  // Region Settings
  getRegionSettings: () => api.get("/admin/settings/region"),
  updateRegionSettings: (data: {
    currency?: string;
    timezone?: string;
    dateFormat?: string;
    numberFormat?: string;
  }) => api.put("/admin/settings/region", data),
};

// ── Extended Localization API ─────────────────────────────────────────────────

export const localizationApi = {
  // Dictionary
  getDictionary: (locale: string, limit = 500) =>
    api.get("/localization/dictionary", { params: { locale, limit } }),

  // Warmup
  warmup: (texts: string[], locale: string) =>
    api.post("/localization/warmup", { texts, locale }),

  // Telemetry
  getMostUsed: (locale?: string, limit = 50) =>
    api.get("/localization/telemetry/most-used", { params: { locale, limit } }),
  getLeastUsed: (locale?: string, limit = 50) =>
    api.get("/localization/telemetry/least-used", {
      params: { locale, limit },
    }),

  // Health
  getHealth: (totalKeys = 50) =>
    api.get("/localization/health", { params: { totalKeys } }),

  // AI Suggestions
  createAISuggestion: (data: {
    locale: string;
    sourceText: string;
    currentTranslation?: string;
    suggestedTranslation: string;
    confidence?: number;
  }) => api.post("/localization/ai-suggest", data),
  listAISuggestions: (params?: { locale?: string; status?: string }) =>
    api.get("/localization/ai-suggestions", { params }),
  reviewAISuggestion: (id: string, decision: "accepted" | "rejected") =>
    api.put(`/localization/ai-suggestions/${id}/review`, { decision }),

  // Community Contributions
  submitContribution: (data: {
    locale: string;
    sourceText: string;
    suggestedTranslation: string;
  }) => api.post("/localization/contributions", data),
  listContributions: (params?: { locale?: string; status?: string }) =>
    api.get("/localization/contributions", { params }),
  reviewContribution: (id: string, decision: "approved" | "rejected") =>
    api.put(`/localization/contributions/${id}/review`, { decision }),
};
